import {Flux} from '@nlabs/arkhamjs';
import {Button} from '@nlabs/gothamui/components';
import {DocumentHead} from '@nlabs/gothamui/head';
import {WorkspaceProvider} from '@nlabs/reaktor-web/provider';
import {useEffect, useState} from 'react';

import {INITIAL_RUNTIME, loadManagedRuntime, MANAGED_RUNTIME_EVENT} from '../runtime.js';

import type {ReactElement} from 'react';
import type {ManagedRuntimeState} from '../runtime.js';

const getSnapshot = (): ManagedRuntimeState => Flux.getState('managed.runtime', INITIAL_RUNTIME);

export const App = (): ReactElement => {
  const [runtime, setRuntime] = useState(getSnapshot);
  useEffect(() => {
    const listener = (): void => {
      setRuntime(getSnapshot());
    };
    Flux.on(MANAGED_RUNTIME_EVENT, listener);
    void loadManagedRuntime(window.location.hostname, Flux);
    return () => {
      Flux.off(MANAGED_RUNTIME_EVENT, listener);
    };
  }, []);

  if(runtime.status === 'loading') {
    return <main aria-live="polite" className="min-h-screen bg-reaktor-page p-6" role="status">Loading application…</main>;
  }
  if(runtime.status === 'unavailable') {
    return <main className="min-h-screen bg-reaktor-page p-6" role="alert">Application unavailable.</main>;
  }
  const {descriptor} = runtime;
  return <WorkspaceProvider appId={descriptor.appId} name={descriptor.name}>
    <main className="min-h-screen bg-reaktor-page p-6 text-reaktor-ink">
      <DocumentHead metadata={{canonicalUrl: descriptor.canonicalUrl, title: descriptor.name}} owner="managed-runtime" />
      <h1 className="text-3xl">{descriptor.name}</h1>
      <p>{descriptor.appId}</p>
      <nav aria-label="Application" className="flex flex-wrap gap-4">
        <Button asChild variant="text"><a href={`${descriptor.canonicalUrl}/api`}>API</a></Button>
        <Button asChild variant="text"><a href={`${descriptor.canonicalUrl}/auth/session`}>Session</a></Button>
      </nav>
    </main>
  </WorkspaceProvider>;
};
